import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAdmin } from '../../../../redux/selectors';
import styles from './PrompthubNav.module.scss';

export default function PrompthubNav() {
  const isAdmin = useSelector(selectIsAdmin);

  return (
    <nav className={styles.root}>
      <NavLink
        to="/prompthub"
        end
        className={({ isActive }) =>
          isActive ? `${styles.link} ${styles.linkActive}` : styles.link
        }
      >
        Каталог
      </NavLink>
      <NavLink
        to="/prompthub/my-prompts"
        className={({ isActive }) =>
          isActive ? `${styles.link} ${styles.linkActive}` : styles.link
        }
      >
        Мои промпты
      </NavLink>
      {Boolean(isAdmin) && (
        <NavLink
          to="/prompthub/cases"
          className={({ isActive }) =>
            isActive ? `${styles.link} ${styles.linkActive}` : styles.link
          }
        >
          Кейсы
        </NavLink>
      )}
    </nav>
  );
}
